import { GetterTree } from "vuex";
import { RootState } from "@/store/types";

import { AuthState } from "../types";

const getters: GetterTree<AuthState, RootState> = {
  getUser(state) {
    return state.user;
  },
  isAuthenticated: (state) => state.isAuthenticated,
  getVerificationEmail: (state) => state.verifyEmail,
};

export default getters;
